var ErrorType = /* @__PURE__ */ function(ErrorType2) {
  ErrorType2["EXCEEDS_STORAGE_LIMIT"] = "exceeds_storage_limit";
  ErrorType2["EXCEEDS_CREDIT_LIMIT"] = "exceeds_credit_limit";
  ErrorType2["EXCEEDS_CHATBOT_LIMIT"] = "exceeds_chatbot_limit";
  ErrorType2["EXCEEDS_ITEM_LIMIT"] = "exceeds_item_limit";
  ErrorType2["FEATURE_NOT_AVAILABLE"] = "feature_not_available";
  ErrorType2["GOOGLE_DRIVE_TOO_MANY_MIRRORS"] = "google_drive_too_many_mirrors";
  ErrorType2["GOOGLE_DRIVE_MIRROR_ALREADY_EXISTS"] = "google_drive_mirror_already_exists";
  ErrorType2["IMPORT_ALREADY_EXISTS"] = "import_already_exists";
  ErrorType2["NOT_ENOUGH_CONTENT"] = "not_enough_content";
  ErrorType2["WOODY_NOT_READY"] = "woody_not_ready";
  ErrorType2["INTEGRATION_AUTHORIZATION_FAILED"] = "err_authorization_failed";
  ErrorType2["INTEGRATION_AUTHORIZATION_ACCESS_DENIED"] = "access_denied";
  ErrorType2["REFERRAL_ALREADY_SET"] = "err_referral_already_set";
  return ErrorType2;
}({});

export { ErrorType };
//# sourceMappingURL=errors.types.js.map
